/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { QnaMakerQnaSwagger, QnaMakerSynonymSwagger } from 'src/qnaMaker/core/services/qnas/QnaMakerAssetsSwaggers';
import { QnaMakerQnaStore } from 'src/qnaMaker/core/stores/QnaMakerQnaStore';
import { QnaMakerSynonymStore } from 'src/qnaMaker/core/stores/QnaMakerSynonymStore';

export const qnaMakerQnaSwaggerToQnaStore = (swagger: QnaMakerQnaSwagger): QnaMakerQnaStore =>
    new QnaMakerQnaStore(swagger.id, {
        ...swagger,
        lastUpdatedDateTime: swagger.lastUpdatedDateTime
    });

export const qnaMakerQnaStoreToQnaSwagger = (store: QnaMakerQnaStore): QnaMakerQnaSwagger => ({
    id: store.id,
    source: store.source,
    isDocumentText: store.isDocumentText,
    answer: store.answer,
    questions: store.questions,
    metadata: store.metadata,
    dialog: store.dialog,
    lastUpdatedDateTime: store.lastUpdatedDateTime
});

export const qnaMakerSynonymSwaggerToSynonymStore = (swagger: QnaMakerSynonymSwagger): QnaMakerSynonymStore =>
    new QnaMakerSynonymStore({ id: swagger.id, alterations: swagger.alterations });

export const QnaMakerSynonymStoreToSynonymSwagger = (store: QnaMakerSynonymStore): QnaMakerSynonymSwagger => ({
    id: store.id,
    alterations: [...store.alterations]
});
